import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import { dashboardTranslations } from "./locales/dashboard";

// Idiomas soportados
const SUPPORTED_LANGUAGES = ["en", "es", "fr"];
const DEFAULT_LANGUAGE = "en";

// Función para detectar el idioma del navegador y retornar uno válido
const detectBrowserLanguage = (): string => {
  // Obtener idioma del navegador
  const browserLang = navigator.language || (navigator as any).userLanguage;

  // Extraer código de idioma (ej: 'en-US' -> 'en')
  const langCode = browserLang.split("-")[0].toLowerCase();

  // Retornar el idioma si está soportado, sino el predeterminado
  return SUPPORTED_LANGUAGES.includes(langCode) ? langCode : DEFAULT_LANGUAGE;
};

// Custom language detector
const languageDetector = {
  type: "languageDetector" as const,
  async: false,
  detect: () => {
    // 1. Intentar obtener de localStorage primero
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang && SUPPORTED_LANGUAGES.includes(storedLang)) {
      return storedLang;
    }

    // 2. Intentar obtener del path de la URL
    const path = window.location.pathname;
    const pathLang = path.split("/")[1];
    if (pathLang && SUPPORTED_LANGUAGES.includes(pathLang)) {
      return pathLang;
    }

    // 3. Detectar del navegador
    return detectBrowserLanguage();
  },
  init: () => {},
  cacheUserLanguage: (lng: string) => {
    if (SUPPORTED_LANGUAGES.includes(lng)) {
      localStorage.setItem("i18nextLng", lng);
    }
  },
};

i18n
  .use(Backend)
  .use(languageDetector as any)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    debug: false,
    load: "languageOnly", // Solo cargar 'en' en lugar de 'en-US'

    ns: ["translation", "dashboard"],
    defaultNS: "translation",

    resources: {
      en: { dashboard: dashboardTranslations.en },
      es: { dashboard: dashboardTranslations.es },
      fr: { dashboard: dashboardTranslations.fr },
    },

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    partialBundledLanguages: true,
  });

// Exportar utilidades
export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, detectBrowserLanguage };
export default i18n;
